import React from "react"
import Seo from "../components/seo"

const Redirect = () => {
  return <Seo title="Youtube Downloader" />
};

export default Redirect